import { createContext, useContext } from 'react';
import type { Studio } from '@/api/schemas';

export const StudioContext = createContext<Studio | null>(null);

export function useStudioData(): Studio {
  const studio = useContext(StudioContext);
  if (!studio) throw new Error('useStudioData outside StudioLayout');
  return studio;
}

export const studioPath = (slug: string, rest = '') => `/s/${slug}/${rest}`.replace(/\/+$/, '/');
